"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListField = void 0;
const field_1 = require("./field");
class ListField extends field_1.Field {
    constructor() {
        super(...arguments);
        this.fields = [];
        this.listFields = [];
    }
}
exports.ListField = ListField;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/list-field.js
// module id = 1244
// module chunks = 0